import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldWrapper } from '@dixa/lib-shared-habla';
import { KnowledgeBaseLinkPreview } from 'components/settings/components/sections/dixaMessenger/views/flow/components/shared/knowledgeBaseLinkPreview';
import { replaceTokensWithTags } from 'fable/tokenInput/utils/replaceTokensWithTags/replaceTokensWithTags';
import styles from './messengerMessagePreview.module.scss';
export const MessengerMessagePreview = ({ text, variables, }) => {
    return (_jsx(FieldWrapper, Object.assign({ label: "Preview", className: styles.root }, { children: _jsxs("div", Object.assign({ className: styles.container }, { children: [!!text && (_jsx(Box, Object.assign({ className: styles.message }, { children: _jsx("div", { 
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: {
                            __html: replaceTokensWithTags(text, variables),
                        } }) }))), _jsx(KnowledgeBaseLinkPreview, { text: text })] })) })));
};
